/**
 * IMPORTS
 */

import { AxiosRequestConfig } from "axios";

import { BASE_API } from "@/environments";

const configAxios: AxiosRequestConfig = {
  // baseURL: "/api", // Ajuste para o namespace do MirageJS
  baseURL: BASE_API,
  timeout: 30000, // Timeout de 10 segundos
  maxContentLength: Infinity, // Aumenta o limite de conteúdo da resposta
  maxBodyLength: Infinity, // Aumenta o limite de corpo da requisição
};

/**
 * EXPORT
 */
export { configAxios };
